"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackEvent = void 0;
var bernie_logger_1 = require("bernie-logger");
// private statics
var ERROR_PREFIX = 'Analytics Error:';
var TIMEOUT = 500;
var PLATFORM_ANALYTICS_ERROR = new bernie_logger_1.SystemEvent(bernie_logger_1.SystemEventLevel.ERROR, 'PLATFORM_ANALYTICS_ERROR');
var MIN_EVENT_LENGTH = 3;
function trackEvent(namespace, rfrr, linkName, uisPrimeMicroMessages, events, trackImmediate, logger, platformAnalytics) {
  if (uisPrimeMicroMessages === void 0) {
    uisPrimeMicroMessages = [];
  }
  if (trackImmediate === void 0) {
    trackImmediate = false;
  }
  if (namespace && (typeof namespace !== 'string' || namespace.length < MIN_EVENT_LENGTH)) {
    throw new Error("".concat(ERROR_PREFIX, " interaction namespace must be empty or a string with a minimum length of ").concat(MIN_EVENT_LENGTH));
  } else if (!namespace) {
    namespace = '';
  }
  if (typeof rfrr !== 'string' || rfrr.length < MIN_EVENT_LENGTH) {
    // throw error if no rfrr is passed, it means we're missing intended tracking
    throw new Error("".concat(ERROR_PREFIX, " tracked event rfrr must be a string with a minimum length of ").concat(MIN_EVENT_LENGTH));
  }
  if (typeof linkName !== 'string' || linkName.length < MIN_EVENT_LENGTH) {
    // throw error if no linkName is passed, it means we're missing intended tracking
    throw new Error("".concat(ERROR_PREFIX, " tracked event linkName must be a string with a minimum length of ").concat(MIN_EVENT_LENGTH));
  }
  if (typeof window === 'object') {
    var label = _setLabel(namespace, rfrr);
    var referrerMicroMessage = {
      schemaName: 'referrer',
      messageContent: {
        referrerId: label,
        linkName: linkName,
        eventType: 'click'
      }
    };
    if (!uisPrimeMicroMessages) {
      uisPrimeMicroMessages = [];
    }
    uisPrimeMicroMessages.push(referrerMicroMessage);
    if (events && Array.isArray(events)) {
      events.forEach(function (event) {
        var eventMicroMessage = {
          schemaName: 'events',
          messageContent: event
        };
        uisPrimeMicroMessages.push(eventMicroMessage);
      });
    }
    var fireTracking = function () {
      try {
        platformAnalytics.trackEvent(uisPrimeMicroMessages);
      } catch (err) {
        if (logger) {
          logger.logEvent(PLATFORM_ANALYTICS_ERROR, err);
        }
      }
    };
    if (trackImmediate) {
      fireTracking();
    } else {
      // free up the UI thread so it can move on to the intended click task
      // and also unblock the event propagation  if this timeout callback throws an error
      setTimeout(fireTracking, TIMEOUT);
    }
  }
}
exports.trackEvent = trackEvent;
function _setLabel(namespace, rfrr) {
  if (!namespace) {
    return rfrr;
  }
  var first = rfrr.charAt(0);
  var hasDelimiter = first === '.' || first === ':' || first === '|';
  var delimiter = hasDelimiter ? '' : '.';
  return namespace.concat(delimiter, rfrr);
}